import React from 'react'
import { PacketModalShell, modalPrimaryButtonStyle } from '../components/PacketModalShell'
import { ReviewNavRail } from './ReviewNavRail'
import { dark, type as typo } from '../tokens'

/**
 * The card that introduces a theme before its ads.
 *
 * A packet carries ~50 ads in a handful of deliberate groupings, and the client
 * works through them alone. Arriving at a new theme's first ad with no marker
 * reads as "another ad"; this says what the next run of ads is trying to do, in
 * the AE's own words, before they start judging them.
 */
export function ReviewThemeSlide({
  label,
  blurb,
  adCount,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  onClose,
}: {
  label: string
  blurb: string | null
  adCount: number
  hasPrev: boolean
  hasNext: boolean
  onPrev: () => void
  onNext: () => void
  onClose: () => void
}) {
  return (
    <>
      <ReviewNavRail hasPrev={hasPrev} hasNext={hasNext} onPrev={onPrev} onNext={onNext} />
      <PacketModalShell palette={dark} onClose={onClose} maxWidth={720} padding={48}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <div
            style={{
              fontFamily: typo.family.sans,
              fontSize: typo.size.eyebrow,
              fontWeight: typo.weight.semibold,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: dark.accent,
            }}
          >
            Theme · {adCount} {adCount === 1 ? 'ad' : 'ads'}
          </div>

          <h2
            style={{
              margin: 0,
              fontFamily: typo.family.serif,
              fontWeight: typo.weight.regular,
              fontSize: typo.size.h1,
              lineHeight: 1.15,
              color: dark.text,
            }}
          >
            {label}
          </h2>

          {blurb && (
            <p
              style={{
                margin: 0,
                fontFamily: typo.family.serif,
                fontSize: typo.size.h3,
                lineHeight: 1.5,
                whiteSpace: 'pre-wrap',
                color: dark.textMuted,
              }}
            >
              {blurb}
            </p>
          )}

          <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
            <button
              type="button"
              onClick={onNext}
              disabled={!hasNext}
              style={{ ...modalPrimaryButtonStyle(dark), flex: '0 0 auto', color: dark.accentInk }}
            >
              See the ads →
            </button>
          </div>
        </div>
      </PacketModalShell>
    </>
  )
}
